import { CurrencyCode } from '@belimo-retrofit-portal/logic';
import { Decimal } from 'decimal.js-light';
import React from 'react';
import { FormattedAmount } from 'src/modules/common/components/FormattedAmount';
import { DECIMAL_PLACES } from 'src/modules/common/constants/decimal';

type Props = {
  readonly value: Decimal | null;
  readonly currency: CurrencyCode;
  readonly precise?: boolean;
};

export const SavingsAmount = ({ value, currency, precise }: Props): React.ReactElement => {
  if (precise) {
    return (
      <FormattedAmount
        value={value}
        currency={currency}
        precision={Number(value?.decimalPlaces()) > 0 ? DECIMAL_PLACES : 0}
      />
    );
  }
  if (value === null) {
    return (
      <FormattedAmount
        value={null}
        currency={currency}
      />
    );
  }

  if (value.isNegative()) {
    return (
      <>
        &lt;
        <FormattedAmount
          value={0}
          currency={currency}
        />
      </>
    );
  }
  if (value.isPositive() && value.lessThan(1_000)) {
    return (
      <>
        &lt;

        <FormattedAmount
          value={1_000}
          currency={currency}
        />
      </>
    );
  }
  if (value.isPositive() && value.greaterThan(1_000_000)) {
    return (
      <>
        <FormattedAmount
          value={value.div(1_000_000)}
          currency={currency}
          precision={2}
        />
        &nbsp;M
      </>
    );
  }

  return (
    <FormattedAmount
      value={value.div(1_000).toDecimalPlaces(0).mul(1_000)}
      currency={currency}
    />
  );
};
